var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header"),
      _c("div", { class: [_vm.getBlackWindows ? "overload" : ""] }),
      _c("div", { staticClass: "layout_body" }, [_c("router-view")], 1),
      _c("Footer", { staticClass: "pt-10" }),
      _c("AlertDialogWS"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }